import { useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { hotDiscussions } from '@/mocks/community';

const topicFilters = [
  { key: 'all', label: '全部讨论' },
  { key: 'top-lx-nanxing', label: '顶流同框' },
  { key: 'top-guzhuang-huanjiao', label: '换角争议' },
  { key: 'top-lianzong-fenshou', label: '恋综CP' },
  { key: 'top-zongyi-jianji', label: '综艺剪辑' },
];

export default function CommunityWall() {
  const [filter, setFilter] = useState('all');
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const list = filter === 'all' ? hotDiscussions : hotDiscussions.filter((item) => item.topicId === filter);

  const toggleLike = (id: string) => setLiked((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        {topicFilters.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setFilter(item.key)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${
              filter === item.key
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:text-primary-700'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
        {list.map((item, index) => (
          <Reveal key={item.id} delay={index * 50}>
            <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-background-50 ${item.avatarBg}`}
                  aria-hidden="true"
                >
                  {item.user.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-semibold text-foreground-900">{item.user}</span>
                  <span className="text-[11px] text-foreground-400">{item.time}</span>
                </span>
              </div>

              <p className="mt-4 flex-1 text-[13px] leading-relaxed text-foreground-700">{item.content}</p>

              <Link
                to={`/topic/${item.topicId}`}
                className="mt-4 flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-900"
              >
                <i className="ri-link" aria-hidden="true" />
                <span className="line-clamp-2-custom">{item.topicTitle}</span>
              </Link>

              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <button
                  type="button"
                  onClick={() => toggleLike(item.id)}
                  aria-pressed={Boolean(liked[item.id])}
                  className={`flex cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors ${
                    liked[item.id]
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-500 hover:bg-background-100'
                  }`}
                >
                  <i className={liked[item.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} aria-hidden="true" />
                  {item.likes + (liked[item.id] ? 1 : 0)}
                </button>
                <Link
                  to={`/topic/${item.topicId}#comments`}
                  className="flex items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  {item.replies} 条回复
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  );
}